import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

export const accountSX: Record<string, (theme: Theme) => SxProps<Theme>> = {
	container: (theme: Theme) => ({
		boxShadow: `${theme.palette.grey[100]} 0 3px 6px`,
		maxHeight: '75vh',
		overflow: 'auto',
	}),
	dropMenu: () => ({
		borderTopRightRadius: 0,
		borderTopLeftRadius: 0,
		maxWidth: 'calc(100vw - 40px)',
		boxShadow: 6,
		backgroundColor: 'background.paper',
		color: 'background.contrastText',
		'@media (hover: hover)': {
			p: 0,
		},
		'.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
			'@media (hover: hover)': {
				mt: 0,
				ml: -2,
			},
			'@media (hover: none)': {
				mt: '1px',
				p: '0',
			},
		},
	}),
	containerMobile: (theme) => ({
		zIndex: 1,
		display: 'flex',
		' > p': {
			paddingTop: '1px',
			paddingLeft: '3px',
		},
		' > span': {
			opacity: 1,
		},
		[theme.breakpoints.up('lg')]: {
			flexDirection: 'column',
			gap: '2px',
			alignItems: 'center',
			justifyContent: 'center',
		},
		[theme.breakpoints.down('lg')]: {
			gap: '10px',
			alignItems: 'center',
			justifyContent: 'center',
		},
	}),
	outlinedIcon: () => ({
		color: 'grey.500',
	}),
	icon: () => ({
		color: 'primary.main',
	}),
	label: (theme) => ({
		display: headerBreak({ xs: 'none', mobile: 'none', desktop: 'block' }),
		textAlign: 'center',
		zIndex: 3000,
		color: 'grey.500',
		[theme.breakpoints.up('md')]: {
			display: 'block',
			fontSize: '15px',
		},
		[theme.breakpoints.up('lg')]: {
			fontSize: '12px',
		},
	}),
	panel: () => ({
		maxHeight: 'none',
	}),
};

export const accountDrawerSX: Record<string, SxProps<Theme>> = {
	container: {
		'& .MuiDrawer-paper': {
			maxHeight: '80vh',
			zIndex: '1600',
			bottom: '60px',
			boxShadow: 3,
			transition: 'none',
		},
	},
};

export const accountItemSX = (isSelected: boolean): SxProps => ({
	display: 'flex',
	cursor: 'pointer',
	borderRadius: '3px',
	minWidth: '50px',
	padding: '10px',
	height: '44px',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: 1,
	'& svg': {
		color: isSelected ? 'primary.main' : 'grey.500',
	},
	'&:hover': {
		backgroundColor: 'grey.50',
		'& svg': {
			color: 'primary.main',
		},
	},
	backgroundColor: isSelected ? 'grey.50' : 'white',
});
